<template>
  <div class="header-container">
    <div class="logo-extender"></div>
    <div class="nav-container">
      <div class="banner">
        <div class="logo">
          <div class="border-container">
            <img src="@/assets/wetterstation-banner.svg" alt="Logo" />
          </div>
        </div>
      </div>
      <nav>
        <ul>
          <li v-for="(navItem, index) in navItems" :key="index">
            <router-link :to="{ name: navItem.name, query: { ...$router.currentRoute.value.query } }">
              {{ navItem.linkText }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      navItems: [
        {
          linkText: "Wetter",
          name: "wetter",
        },
        {
          linkText: "Projekt",
          name: "projekt",
        },
        {
          linkText: "Galerie",
          name: "galerie",
        },
        {
          linkText: "Daten",
          name: "daten",
        },
        {
          linkText: "Team",
          name: "team",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
div,
nav,
footer {
  z-index: 15;
}
.header-container {
  z-index: 15;
  position: fixed;
  background: $hs-blue-primary;
  left: 0;
  right: 0;
  top: 0;
}
.logo-extender {
  display: none;
  width: 16px;
  @media screen and (min-width: $desktopSize) {
    display: block;
    width: calc((100vw - 1024px + 48px) / 2);
    position: fixed;
    height: 80px;
    background: $hs-blue-primary;
  }
}
.nav-container {
  position: relative;
  max-width: 1024px;
  margin: auto;
  padding: 0 16px 0 16px;
  display: grid;
  grid-template-columns: calc(200px + 16px) 1fr;
  min-height: 64px;
  @media screen and (min-width: $desktopSize) {
    grid-template-columns: calc(370px + 16px) 1fr;
    min-height: 80px;
  }
}
.banner {
  position: relative;
  height: 100%;
}
.logo {
  height: 100%;
  width: 100%;
  max-height: 64px;
  @media screen and (min-width: $desktopSize) {
    max-height: 80px;  /* NEU */
  }
}
.border-container {
  width: 100%;
  height: 100%;
  border-left: solid $hs-blue-primary 3px;
  border-bottom: solid $hs-blue-primary 3px;
  @media screen and (min-width: $tabletSize) {
    border-bottom: solid $hs-blue-primary 2px;
  }
  @media screen and (min-width: $desktopSize) {
    border-bottom: solid $hs-blue-primary 3px;
  }
}
img {
  display: block;
  width: 130%;
  height: 100%;
  object-fit: contain;
  object-position: left center;  /* wiederherstellen */
  max-height: 64px;
  @media screen and (min-width: $desktopSize) {
    max-height: 80px;  /* NEU */
  }
}
nav {
  display: flex;
  align-items: center;
}
ul {
  list-style-type: none;
  width: 100%;
  margin: 0;
  padding: 0 16px 0 35px;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
li {
  transition: all 0.2s;
}
li:hover {
  transform: scale(1.2) translateY(5px);
}
a {
  text-decoration: none;
  font-size: 24px;
  color: $white;
}
</style>
